<template>
  <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
    <div v-if="value" class="flex items-center justify-between">
      <div class="flex-1">
        <div class="flex items-center">
          <div class="flex-1">
            <p
              class="text-sm font-medium text-gray-600 tracking-wide"
            >
              {{ label }}
            </p>
            <p class="text-2xl font-bold text-gray-900">
              {{ value }}
            </p>
            <p v-if="compareValue" :class="getCompareValueColor" class="text-sm font-medium">
              {{ compareValue }}
            </p>
          </div>
          <div v-if="icon" class="flex-shrink-0 ml-4">
            <div
              class="w-12 h-12 rounded-lg flex items-center justify-center relative"
              :class="iconBackgroundClass"
            >
              <Icon :icon-name="icon"  />
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import Icon from './Icon.vue';
export default {
  name: "MetricCard",
  components: {
    Icon
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: [Number, String],
      required: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: "blue",
      validator: value =>
        [
          "blue",
          "green",
          "red",
          "yellow",
          "purple",
          "indigo",
          "orange"
        ].includes(value)
    },
    compareValue: {
      type: String,
      default: null
    },
    compareValueColor: {
      type: String,
      default: 'green'
    }
  },
  computed: {
    iconBackgroundClass() {
      const colorMap = {
        blue: "bg-blue-200",
        green: "bg-green-200",
        red: "bg-red-200",
        yellow: "bg-yellow-200",
        purple: "bg-purple-200",
        indigo: "bg-indigo-200",
        orange: "bg-orange-500"
      };
      return colorMap[this.iconColor] || "bg-blue-500";
    },
    getColor() {
      const colorMap = {
        blue: "text-blue-500",
        green: "text-green-500",
        red: "text-red-500",
        yellow: "text-yellow-500",
        purple: "text-purple-500",
        indigo: "text-indigo-500",
        orange: "text-orange-500"
      };
      return colorMap[this.iconColor] || "text-blue-500";
    },
    getCompareValueColor() {
      const colorMap = {
        green: 'text-green-600',
        red: 'text-red-600'
      }
      return colorMap[this.compareValueColor] || "text-green-600"
    }
  }
};
</script>

<style scoped>
.text-2xl {
  font-size: 1.7rem !important;
}
</style>
